import { select, put, race, take, call, delay } from 'redux-saga/effects'
import { SET_DELAYING_SPIN, SET_SKIPFEATURE } from '../redux/constants'
import { setSkipFeature } from '../redux/actions'
import Timeout from './Timeout'


function* TakeSkip() {
  const { delayingSpin } = yield select(state => state.base)

  if (delayingSpin) {
    yield take(SET_DELAYING_SPIN)
  }

  yield take(action => action.type === SET_SKIPFEATURE && action.skipfeature)
}

/**
 * Generator function that will add a delay that will be paused
 * if the game gets paused. It can also be skipped if "skipfeature"
 * get set to true.
 * @param {number} time - How long (in milliseconds) the delay will try to last.
 */
export default function* delayOrSkip(time) {
  if (!time) { return }

  let _timeout

  function getTimePromise(time) {
    return new Promise(resolve => { _timeout = new Timeout(resolve, time) })
  }

  const { stepDebug, skipfeature } = yield select(state => state.base)

  let ret = time

  if (!skipfeature) {
    yield race({
      skip: TakeSkip(),
      timeout: call(getTimePromise, time)
    })

    yield delay(0)

    ret = _timeout.cancel()
  }

  if (stepDebug) {
    yield put(setSkipFeature(false))
  }

  return ret
}
